/// <reference path="../../../../node_modules/@types/globalize/index.d.ts" />
/// <reference path="../../common/forms/forms.ts" />
/// <reference path="../../../teva/storage/storage.ts" />

namespace OfficeGuy.Website {
    export class Users {
        static ShowHideCompany(CompanyID: number, $Link) {
            var Icon = $Link.find("span");
            var Hidden = Icon.hasClass("icon-heart");
            Icon.toggleClass("icon-heart", !Hidden).toggleClass("icon-heart-empty", Hidden);

            Common.AjaxRequest({
                URL: "/companies/showhide/",
                Data: {
                    CompanyID: CompanyID,
                    Hidden: Hidden
                }
            });
            return false;
        }

        static InitEmailAddress($Selector) {
            if ($Selector.val() == "")
                $Selector.val(Teva.Storage.LocalStorage_Get("EmailAddress")).trigger("change");
            $Selector.closest("form").on("submit", function () {
                Teva.Storage.LocalStorage_Set("EmailAddress", $Selector.val());
                return true;
            });
        }

        static EmailLogin() {
            $('#Action').val("Email");
            $('#Password').val("");
            Forms.SubmitForm($('#Password').closest("form"));
            return false;
        }
    }
}